import { render } from "./lnstructions.vue?vue&type=template&id=55612b75&scoped=true"
import script from "./lnstructions.vue?vue&type=script&lang=js"
export * from "./lnstructions.vue?vue&type=script&lang=js"

import "./lnstructions.vue?vue&type=style&index=0&id=55612b75&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55612b75"]])

export default __exports__